import { Center, Image, Paper, Stack, Text, Title } from "@mantine/core";

import type { ErrorPropsType } from "./type";

export default function Error({ imageUrl, title, description, bgColor }: ErrorPropsType) {
  return (
    <Center mih="100vh" bg={bgColor} px="md">
      <Paper p={{ base: "lg", sm: "xl" }} shadow="lg" bdrs="xl">
        <Image src={imageUrl} alt={title} bdrs="xl" fit="contain" mb="sm" />
        <Stack align="center" gap="md" ta="center">
          <Title size="h4">{title}</Title>
          <Text size="md">{description}</Text>
        </Stack>
      </Paper>
    </Center>
  );
}
